import React from 'react';
import { Typography, Button, ButtonGroup } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import {
  isTicketWithTroubleProtocol,
  isTicketWithInstallationProtocol,
  sortByDate,
} from '../../../helperFunctions/index';
import { setData } from '../../redux';

export default ({ task }) => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const { documentsDashboard, installationProtocol, troubleProtocol } = task;
  const data = useSelector(state => state.tasks.data);
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const fontSize = width <= 500 ? '4vw' : '20px';

  const hasClientInformation = documentsDashboard && documentsDashboard.clientInformation;
  return hasClientInformation &&
    (isTicketWithTroubleProtocol(task.ticketTypeId) ||
      isTicketWithInstallationProtocol(task.ticketTypeId) ||
      task.isIts) ? (
    <>
      <ButtonGroup
        style={{
          marginTop: '5px',
          marginBottom: '5px',
          width: '100%',
          position: 'sticky',
          top: '0',
          zIndex: '100',
        }}
      >
        <Button
          onClick={() => {
            if (
              documentsDashboard &&
              documentsDashboard.contractSigningUrl &&
              documentsDashboard.isContractSignatureRequestPending
            ) {
              window.open(documentsDashboard.contractSigningUrl, '_blank');
              return;
            }

            if (
              documentsDashboard &&
              documentsDashboard.protocolSigningUrl &&
              documentsDashboard.isProtocolSignatureRequestPending
            ) {
              window.open(documentsDashboard.protocolSigningUrl, '_blank');
              return;
            }
            const updatednstallationProtocol = { ...installationProtocol };
            updatednstallationProtocol.isAllClientDevicesLoaded = false;
            const updatedTroubleProtocol = { ...troubleProtocol };
            updatedTroubleProtocol.isAllClientDevicesLoaded = false;

            const updatedTasks = [...data.tasks];
            updatedTasks.splice(taskIndex, 1, {
              ...task,
              documentsDashboard: { ...documentsDashboard, open: true },
              installationProtocol: updatednstallationProtocol,
              troubleProtocol: updatedTroubleProtocol,
            });

            dispatch(
              setData({
                ...data,
                tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
              })
            );
          }}
          variant="contained"
          color="secondary"
          style={{ width: '99%' }}
        >
          <Typography gutterBottom component="span" style={{ fontSize }}>
            Подпиши документи
          </Typography>
        </Button>
      </ButtonGroup>
    </>
  ) : (
    <></>
  );
};
